'use client';

import Link from 'next/link';

export default function PageError({ reset }) {
  return (
    <div className="container mx-auto px-4 py-24 text-center">
      <h1 className="font-cormorant text-4xl text-primary mb-4">
        Something went wrong
      </h1>
      <p className="font-worksans text-base text-black mb-8">
        We couldn&apos;t load this page. Please try again.
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <button
          onClick={reset}
          className="px-6 py-3 bg-sea text-white rounded-full font-worksans text-base"
        >
          Try again
        </button>
        <Link
          href="/"
          className="px-6 py-3 bg-sea text-white rounded-full font-worksans text-base"
        >
          Go to Homepage
        </Link>
      </div>
    </div>
  );
}
